import { LocalData } from "../to-be-removed/LocalData/General/LocalData";
import { t } from "i18next";

export class StringUtilities {
  static toTitleCase(str: string) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
  static replaceAll(string: string, searchValue: string | RegExp, replaceValue: string): string {
    try {
      if (!string.replaceAll) {
        return string;
      } else {
        return string.replaceAll(searchValue, replaceValue);
      }
    } catch (error) {
      return string;
    }
  }

  static trimEnd(string: string): string {
    try {
      if (!string.trimEnd) {
        return string;
      } else {
        return string.trimEnd();
      }
    } catch (error) {
      return string;
    }
  }

  static trimStart(string: string): string {
    try {
      if (!string.trimStart) {
        return string;
      } else {
        return string.trimStart();
      }
    } catch (error) {
      return string;
    }
  }

  static createString(list: string[], maxElements: number = 3): string {
    var text = "";
    for (let i = 0; i < Math.min(maxElements, list.length); i++) {
      if (!list[i]) continue;
      text += list[i];

      if (list.length <= maxElements && i === list.length - 2) {
        text += " " + t("main.and") + " ";
      } else if (i < Math.min(maxElements, list.length) - 1) {
        text += ", ";
      }
    }

    if (list.length > maxElements) {
      text += " + " + (list.length - maxElements) + " " + (list.length - maxElements === 1 ? t("main.other_people") : t("main.others_people"));
    }
    return text;
  }

  static getGreeting() {
    let greeting = "";
    let now = new Date();
    if (now.getHours() < 6) {
      greeting = "🌃 " + t("main.goodNight");
    } else if (now.getHours() < 9) {
      greeting = "🌄 " + t("main.goodMorning");
    } else if (now.getHours() < 12) {
      greeting = "⛅ " + t("main.goodLateMorning");
    } else if (now.getHours() < 18) {
      greeting = "☀️ " + t("main.goodAfternoon");
    } else if (now.getHours() < 24) {
      greeting = "🌇 " + t("main.goodEvening");
    }
    return greeting + (LocalData.currentUser.name ? " " + LocalData.currentUser.name.split(" ")[0] + "!" : "");
  }

  static createOrString(list: string[]): string {
    var text = "";
    for (let i = 0; i < list.length; i++) {
      text += list[i];

      if (i === list.length - 2) {
        text += " " + t("main.or") + " ";
      } else if (i < list.length - 1) {
        text += ", ";
      }
    }
    return text;
  }

  static stringIsEmoji(text: string): boolean {
    const regex = /\p{Extended_Pictographic}/gu;
    return regex.test(text);
  }
  static capitalize(word: string) {
    return word.charAt(0).toUpperCase() + word.toLocaleLowerCase().substring(1);
  }

  static getPropertyIDFromPath(path: string): string {
    // Based on a path like "properties/1234567890", this function returns "1234567890"
    const pathParts = path.split("/");
    const propertyIndex = pathParts.indexOf("properties");
    if (propertyIndex === -1) {
      return "";
    }
    return pathParts[propertyIndex + 1];
  }

  static formatPhoneWithCountryCode(phone: string): string {
    let formattedPhone = phone;
    // Remove all non-numeric characters except for the plus sign
    formattedPhone = formattedPhone.replace(/[^0-9+]/g, "");
    // Remove leading zeros
    formattedPhone = formattedPhone.replace(/^0+/, "");

    // Check if starts with a plus sign, and return the phone number as is
    if (formattedPhone.startsWith("+")) {
      return formattedPhone;
    }

    if (formattedPhone.length === 10) {
      formattedPhone = "+" + formattedPhone;
    } else if (formattedPhone.length === 8) {
      formattedPhone = "+47" + formattedPhone;
    }

    return formattedPhone;
  }
}

